"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryString = _interopRequireDefault(require("query-string"));
var _axios = require("axios");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RestService = exports.default = /*#__PURE__*/function () {
  function RestService(axios, resourcePath) {
    _classCallCheck(this, RestService);
    this.axios = axios;
    this.resourcePath = resourcePath;
  }

  /**
   *
   * @param condition
   * @param pathname
   * @param cancelRef
   * @returns {Promise<{}>}
   */
  return _createClass(RestService, [{
    key: "search",
    value: (function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(condition, pathname) {
        var cancelRef,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cancelRef = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                current: null
              };
              if (!pathname) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return this.axios.get("".concat(this.resourcePath, "/").concat(pathname, "?").concat(_queryString.default.stringify(condition)), {
                timeout: condition.timeoutRequestAPI || this.axios.defaults.timeout
              });
            case 4:
              return _context.abrupt("return", _context.sent);
            case 5:
              _context.next = 7;
              return this.axios.get("".concat(this.resourcePath, "?").concat(_queryString.default.stringify(condition)), {
                timeout: condition.timeoutRequestAPI || this.axios.defaults.timeout,
                cancelToken: new _axios.CancelToken(function (callback) {
                  cancelRef.current = callback;
                })
              }).finally(function () {
                cancelRef.current = null;
              });
            case 7:
              return _context.abrupt("return", _context.sent);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function search(_x, _x2) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
    /**
     *
     * @param id
     * @param params
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "detail",
    value: (function () {
      var _detail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id, params) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!params) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return this.axios.get("".concat(this.resourcePath, "/").concat(id), {
                params: params
              });
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 4:
              _context2.next = 6;
              return this.axios.get("".concat(this.resourcePath, "/").concat(id));
            case 6:
              return _context2.abrupt("return", _context2.sent);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function detail(_x3, _x4) {
        return _detail.apply(this, arguments);
      }
      return detail;
    }()
    /**
     *
     * @param id
     * @param updatedData
     * @returns {Promise<void>}
     */
    )
  }, {
    key: "update",
    value: (function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id, updatedData) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.axios.put("".concat(this.resourcePath, "/").concat(id), updatedData);
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function update(_x5, _x6) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     *
     * @param actionName
     * @param updatedData
     * @returns {Promise<void>}
     */
    )
  }, {
    key: "updateByAction",
    value: (function () {
      var _updateByAction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(actionName, updatedData) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.axios.patch("".concat(this.resourcePath, "/").concat(actionName), updatedData);
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateByAction(_x7, _x8) {
        return _updateByAction.apply(this, arguments);
      }
      return updateByAction;
    }()
    /**
     *
     * @param creatingPayload
     * @param pathname
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "create",
    value: (function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(creatingPayload, pathname) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!pathname) {
                _context5.next = 4;
                break;
              }
              _context5.next = 3;
              return this.axios.post("".concat(this.resourcePath, "/").concat(pathname), creatingPayload);
            case 3:
              return _context5.abrupt("return", _context5.sent);
            case 4:
              _context5.next = 6;
              return this.axios.post("".concat(this.resourcePath), creatingPayload);
            case 6:
              return _context5.abrupt("return", _context5.sent);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function create(_x9, _x10) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
    /**
     *
     * @param id
     * @param params
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "delete",
    value: (function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(id, params) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!params) {
                _context6.next = 4;
                break;
              }
              _context6.next = 3;
              return this.axios.delete("".concat(this.resourcePath, "/").concat(id, "?").concat(_queryString.default.stringify(params)));
            case 3:
              return _context6.abrupt("return", _context6.sent);
            case 4:
              _context6.next = 6;
              return this.axios.delete("".concat(this.resourcePath, "/").concat(id));
            case 6:
              return _context6.abrupt("return", _context6.sent);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function _delete(_x11, _x12) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     *
     * @param type
     * @param file
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "uploadFile",
    value: (function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(type, file) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.axios.post("/upload?type=".concat(type), file);
            case 2:
              return _context7.abrupt("return", _context7.sent);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function uploadFile(_x13, _x14) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
    /**
     *
     * @param id
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "lock",
    value: (function () {
      var _lock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(id) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.axios.get("/lock".concat(this.resourcePath, "/").concat(id));
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function lock(_x15) {
        return _lock.apply(this, arguments);
      }
      return lock;
    }()
    /**
     *
     * @param id
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "unlock",
    value: (function () {
      var _unlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(id) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.axios.delete("/lock".concat(this.resourcePath, "/").concat(id));
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function unlock(_x16) {
        return _unlock.apply(this, arguments);
      }
      return unlock;
    }()
    /**
     *
     * @param requestBodyData
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "assignments",
    value: (function () {
      var _assignments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(requestBodyData) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.axios.post("".concat(this.resourcePath), requestBodyData);
            case 2:
              return _context10.abrupt("return", _context10.sent);
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function assignments(_x17) {
        return _assignments.apply(this, arguments);
      }
      return assignments;
    }()
    /**
     *
     * @param updateRoleRequest
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "setRole",
    value: (function () {
      var _setRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(updateRoleRequest) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.axios.put("".concat(this.resourcePath), updateRoleRequest);
            case 2:
              return _context11.abrupt("return", _context11.sent);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function setRole(_x18) {
        return _setRole.apply(this, arguments);
      }
      return setRole;
    }()
    /**
     *
     * @param exportType
     * @param requestBody
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "exportDocument",
    value: (function () {
      var _exportDocument = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(exportType, requestBody) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.axios.post("".concat(this.resourcePath, "/").concat(exportType), requestBody);
            case 2:
              return _context12.abrupt("return", _context12.sent);
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function exportDocument(_x19, _x20) {
        return _exportDocument.apply(this, arguments);
      }
      return exportDocument;
    }()
    /**
     *
     * @param pathname
     * @param requestBody
     * @param requestParams
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "postRequest",
    value: (function () {
      var _postRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(pathname, requestBody, requestParams) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.axios.post("".concat(this.resourcePath).concat(pathname), requestBody, {
                params: requestParams
              });
            case 2:
              return _context13.abrupt("return", _context13.sent);
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function postRequest(_x21, _x22, _x23) {
        return _postRequest.apply(this, arguments);
      }
      return postRequest;
    }()
    /**
     *
     * @param pathname
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "exportExcel",
    value: (function () {
      var _exportExcel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(pathname) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.axios.get("".concat(this.resourcePath).concat(pathname));
            case 2:
              return _context14.abrupt("return", _context14.sent);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function exportExcel(_x24) {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }()
    /**
     *
     * @param id
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "lazyLoad",
    value: (function () {
      var _lazyLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(id) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.axios.get("/users/lazy-load/".concat(id));
            case 2:
              return _context15.abrupt("return", _context15.sent);
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function lazyLoad(_x25) {
        return _lazyLoad.apply(this, arguments);
      }
      return lazyLoad;
    }()
    /**
     *
     * @param id
     * @param requestBody
     * @returns {Promise<*>}
     */
    )
  }, {
    key: "patch",
    value: (function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(id, requestBody) {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.axios.patch("".concat(this.resourcePath, "/").concat(id), requestBody);
            case 2:
              return _context16.abrupt("return", _context16.sent);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function patch(_x26, _x27) {
        return _patch.apply(this, arguments);
      }
      return patch;
    }())
  }]);
}();